import Vue from 'vue'
import Vuex from 'vuex'
import ENG_store from "@/components/IBMS/platform/platform_store";
import Login_store from "@/components/IBMS/login/login_store";
import header_store from "@/components/IBMS/header/header_store";


Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        public_key: "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDffoEetAj3iWuM98Vg5tADE6E/c7+XycXgWRU8ORYkfNeXXRiNPesX2uPmXFJNXJ3EJCqsAT/47yvFh2jwPkDsrF4fv9oPmJKacHPnoR62mqM9sXQ12XkR5yHjMZRf9hTGp457SIoktMx4JSK8Gvv68DTSnrLtOwNow+f7YzAGXwIDAQAB-----END PUBLIC KEY-----",
        time_data: [],//时间数据
        proName: '',
        pro_id: '',
        buildingList: [],
        //工单时间选择器组件数据
        work_time_box: [],
        //工单分页组件当前页数据
        work_pagination_current_page: 1,
        //工单分页组件总条数数据
        work_pagination_total_num: 0,
        //工单分页组件每页大小数据
        work_pagination_current_size: 15,
        //修改后
        project_data: [],//项目属性数据
        funcGroup_data: [],//功能组数据
        building_data: [],//建筑属性数据
        plat_data:[],//平台属性数据
        function_data: [],//关联功能对象数据
        user_data: [],//关联用户对象数据
        objs_data: [],
        role_data: [],//角色属性数据
        new_item_attr_list: [],//新建分类属性列表
        new_energy_attr_list: [],//新建能耗模型属性列表
        item_tree: [],//分项、空间组合、设备组合树结构
        item_equipment_data: [],//分类关联设备
        new_auth_data: [],//新建权限数据
        new_func_data: [],//新建功能模块数据
        ...Login_store.state,
        ...ENG_store.state,
        ...header_store.state,
    },
    mutations: {
        //新建权限
        set_new_auth_data(state, data) {
            state.new_auth_data = data
        },
        //新建功能模块
        set_new_func_data(state, data) {
            state.new_func_data = data
        },
        //分类关联设备
        set_item_equipment_data(state, data) {
            state.item_equipment_data = data
        },
        //新增能耗模型属性列表
        set_new_energy_attr_list(state, data) {
            state.new_energy_attr_list = data
        },
        //新增分类属性列表
        set_new_item_attr_list(state, data) {
            state.new_item_attr_list = data
        },
        set_role_data(state, data) {
            state.role_data = data
        },

        set_user_data(state, data) {
            state.user_data = data
        },
        set_function_data(state, data) {
            state.function_data = data
        },
        set_project_data(state, data) {
            state.project_data = data
        },
        set_funcGroup_data(state, data) {
            state.funcGroup_data = data
        },
        set_building_data(state, data) {
            state.building_data = data
        },
        set_plat_data(state, data) {
            state.plat_data = data
        },

        //关系项目名称
        getproName(state, data) {
            state.proName = data
        },
        //关系项目名称
        getproId(state, data) {
            state.pro_id = data
        },
        //建筑列表
        getBuildList(state, data) {
            state.buildingList = data
        },


        // 工单时间选择器
        get_work_time(state, data) {
            state.work_time_box = data
        },
        // 工单分页当前页
        get_pagination_current_page(state, data) {
            state.work_pagination_current_page = data
        },
        // 工单分页总条数
        get_pagination_total_num(state, data) {
            state.work_pagination_total_num = data
        },
        // 工单分页每页条数
        get_pagination_current_size(state, data) {
            state.work_pagination_current_size = data
        },
        ...Login_store.mutations,
        ...ENG_store.mutations,
        ...header_store.mutations,
    },
    actions: {
        set_project_data({commit}, payload) {
            commit('set_project_data', payload)
        },
        ...Login_store.actions,
        ...ENG_store.actions,
        ...header_store.actions,
    },
    getters: {

        //修改项目属性
        set_project_value(state) {
            return function (code, value) {
                let data_list = state.project_data
                let x = data_list.object_data.static_attribute.findIndex(item => item.c_code === code)
                let y = data_list.object_data.static_attribute.find(item => item.c_code === code)
                y.c_value = value
                data_list.object_data.static_attribute.splice(x, 1, y)
                store.commit('set_project_data', data_list)
            }
        },
        //功能組屬性
        set_funcGrounp_value(state) {
            return function (id, value) {
                let data_list = state.funcGroup_data
                let x = data_list.static_attribute.findIndex(item => item.c_code === id)
                let y = data_list.static_attribute.find(item => item.c_code === id)
                y.c_value = value
                data_list.static_attribute.splice(x, 1, y)
                console.log(data_list)
                store.commit('set_funcGroup_data', data_list)
            }
        },
        //修改建筑属性
        set_building_value(state) {
            return function (Data,code, value) {
                let data_list = state.building_data
                console.log(data_list, 'cf')
                if(Data.attr.type==='1'){
                    let x = data_list.static_attribute.findIndex(item => item.c_code === code)
                    let y = data_list.static_attribute.find(item => item.c_code === code)
                    y.c_value = value
                    data_list.static_attribute.splice(x, 1, y)
                    console.log(data_list,'data_list')
                }else {
                    let x = data_list.special_attribute.findIndex(item => item.c_code === code)
                    let y = data_list.special_attribute.find(item => item.c_code === code)
                    y.c_value = value
                    data_list.special_attribute.splice(x, 1, y)
                    console.log(data_list,'data_list')
                }
                store.commit('set_building_data', data_list)
            }
        },
        //修改用户对象
        set_user_object(state) {
            return function (value) {
                let data_obj = state.user_data
                data_obj = value
                store.commit('set_user_data', data_obj)
            }
        },
        //修改角色属性
        set_role_data(state) {
            return function (code, value) {
                let data_list = state.role_data
                let x = data_list.static_attribute.findIndex(item => item.c_code === code)
                let y = data_list.static_attribute.find(item => item.c_code === code)
                y.c_value = value
                data_list.static_attribute.splice(x, 1, y)
                store.commit('set_role_data', data_list)
            }
        },
        //新增分类列表
        set_new_item_attr_list(state) {
            return function (code, value) {
                let data_list = state.new_item_attr_list
                let x = data_list.static_attribute.findIndex(item => item.c_code === code)
                let y = data_list.static_attribute.find(item => item.c_code === code)
                y.c_value = value
                data_list.static_attribute.splice(x, 1, y)
                store.commit('set_new_item_attr_list', data_list)
            }
        },
        //新增能耗模型列表
        set_new_energy_attr_list(state) {
            return function (code, value) {
                console.log(value,'sd')
                let data_list = state.new_energy_attr_list
                let x = data_list.static_attribute.findIndex(item => item.c_code === code)
                let y = data_list.static_attribute.find(item => item.c_code === code)
                y.c_value = value
                data_list.static_attribute.splice(x, 1, y)
                console.log(data_list,'data_lll')
                store.commit('set_new_energy_attr_list', data_list)
            }
        },

        //修改分类关联设备
        set_item_equipment_data() {
            return function (value) {
                store.commit('set_item_equipment_data', value)
            }
        },
        //修改新建功能模块属性
        set_new_func_data(state) {
            console.log(state.new_func_data,'123')
            return function (id, value) {
                let data_list = state.new_func_data
                let x = data_list.findIndex(item => item.c_id === id)
                let y = data_list.find(item => item.c_id === id)
                y.c_value = value
                data_list.splice(x, 1, y)
                store.commit('set_new_func_data', data_list)
            }
        },
        set_build_info(state) {
            return function (data, id, value) {
                var i = data.attr.index
                let data_list = state.building_data
                let x = data_list[i].findIndex(item => item.c_code === id)
                let y = data_list[i].find(item => item.c_code === id)
                y.c_value = value
                data_list[i].splice(x, 1, y)
                store.commit('set_building_data', data_list)
            }
        },
        //新建平台
        set_plat_info(state) {
            return function (data, id, value) {
                let data_list = state.plat_data
                let x = data_list.object_data.static_attribute.findIndex(item => item.c_code === id)
                let y =  data_list.object_data.static_attribute.find(item => item.c_code === id)
                y.c_value = value
                data_list.object_data.static_attribute.splice(x, 1, y)
                console.log(data_list, '123')

                store.commit('set_plat_data', data_list)
            }
        },
        ...Login_store.getters,
        ...ENG_store.getters,
        ...header_store.getters,
    }
});
export default store
